"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionService = void 0;
var app_1 = require("app");
var SessionService = /** @class */ (function () {
    function SessionService() {
    }
    SessionService.prototype.GetSessionId = function () {
        this.sessionId = this.sessionId || app_1.UtilService.newUUID();
        return this.sessionId;
    };
    SessionService.prototype.setDataToStorage = function (key, value) {
        window.sessionStorage.setItem(key, value);
    };
    SessionService.prototype.getDataFromStorage = function (key) {
        return window.sessionStorage.getItem(key);
    };
    SessionService.prototype.removeDataFromStorage = function (key) {
        window.sessionStorage.removeItem(key);
    };
    return SessionService;
}());
var service = new SessionService();
exports.SessionService = service;
